module.exports = __webpack_public_path__ + "img/ic_more_menu.98bf6283.svg";